/**
 * Leaf helper for resolving a loyalty promo key from bonus calculation results.
 * Kept out of promoMappers so loyalty points-calculation selectors can use it
 * without pulling getCheckoutPointsCalculationRequests (and the promo ↔ points cycle).
 */

type FilterPromoKeysByProductTypeProps = {
  loyaltyPointsBonusResultV1?: App.Promotion['loyaltyPointsBonusResultV1']
  filter: {
    itemId: string | undefined
  }
}

export const getPromoKeyForLoyaltyItem = (
  result: App.Promotion['loyaltyPointsBonusResultV1'] | undefined,
  filter: FilterPromoKeysByProductTypeProps,
): string | undefined => {
  if (!result) {
    return undefined
  }

  return result.loyaltyCalculationResponseItems.find((item) => item.itemId === filter.filter.itemId)?.promoKey
}
